<cai-settings-layout
  tabTitle="Company & office settings"
  [items]="navItems"
  [selectedNavItem]="activeTab"
  [selectedNavSubItem]="activeSubTab"
  (onSelectNavItem)="onSelectNavItem($event)"
  (onSelectNavSubItem)="onSelectNavSubItem($event)"
>
  <div class="main-container">
    @if (activeTab === "office-settings") {
      <kt-company-settings></kt-company-settings>
    }
    @if (activeTab === "office-management") {
      <cai-office-management
        [activeOffice]="activeOffice"
        [currentUser]="currentUser"
        [companyOffices]="companyOffices"
        [openViewPlans]="shouldOpenViewPlans"
        [openUpgradePlans]="shouldOpenUpgradePlans"
        (displayedViewPlans)="onDisplayedViewPlans($event)"
        (onUpdateActiveOffice)="updateOffice($event)"
      ></cai-office-management>
    }
    @if (activeTab === "office-charges") {
      <cai-office-charges
        [activeOffice]="activeOffice"
        [currentUser]="currentUser"
      ></cai-office-charges>
    }
    @if (activeTab === "office-customers") {
      <cai-office-customers
        [activeOffice]="activeOffice"
      ></cai-office-customers>
    }
    @if (activeTab === "office-terms-and-conditions") {
      <cai-office-terms-and-conditions
        [activeOffice]="activeOffice"
        [currentUser]="currentUser"
      ></cai-office-terms-and-conditions>
    }
    @if (activeTab === "office-rate-markup") {
      <cai-office-rate-markup
        [activeOffice]="activeOffice"
        [currentUser]="currentUser"
      ></cai-office-rate-markup>
    }
  </div>
</cai-settings-layout>
